import { isMobile } from "react-device-detect";

function Preload(images, sounds, delay, callback) {
    let current = 0;
    const total = images.length + sounds.length;

    const loadImage = (index) => {
        setTimeout(() => {
            //console.log("loading image>" + images[index]);
            const img = document.createElement("img");
            img.style.display = "none";
            document.body.appendChild(img);
            img.onload = () => {
                //console.log("table " + index + " loaded");
                current++;
                document.body.removeChild(img);
                callback(current, total);
                if (index < images.length - 1) {
                    loadImage(index + 1);
                }
            };
            img.onerror = () => {
                //console.log("table " + index + " loaded");
                current++;
                document.body.removeChild(img);
                callback(current, total);
                if (index < images.length - 1) {
                    loadImage(index + 1);
                }
            };
            img.src = images[index];
        }, delay);
    };

    const loadSound = (index) => {
        setTimeout(() => {
            //console.log("loading sound>", sounds[index]);
            const sound = document.createElement("audio");
            sound.preload = "auto";
            sound.style.display = "none";
            document.body.appendChild(sound);
            sound.onloadeddata = () => {
                current++;
                //console.log("sound " + index + " loaded");
                document.body.removeChild(sound);
                callback(current, total);
                if (index < sounds.length - 1) {
                    loadSound(index + 1);
                } else {
                    loadImage(0);
                    //console.log();
                }
            };
            sound.onerror = () => {
                current++;
                //console.log("sound " + index + " not loaded");
                document.body.removeChild(sound);
                callback(current, total);
                if (index < sounds.length - 1) {
                    loadSound(index + 1);
                } else {
                    loadImage(0);
                    //console.log();
                }
            };
            sound.src = sounds[index];
            sound.pause();
        }, delay);
    };

    if (!isMobile) {
        if (sounds.length > 0) {
            loadSound(0);
        } else {
            loadImage(0);
        }
    } else {
        var interval = setInterval(() => {
            current++;
            callback(current, total);
            if (current === total) {
                clearInterval(interval);
            }
        }, delay);
    }
}
export default Preload;